import React from 'react';

import Icons, { IconName } from '@/core/components/Icons';

export type SliderNavigationProps = {
  buttonRef: React.RefObject<null>;
  type: 'next' | 'prev';
};

export const SliderNavigation: React.FC<SliderNavigationProps> = ({ buttonRef, type }) => {
  const typeToIcon: { [key in SliderNavigationProps['type']]: IconName } = {
    prev: 'chevron-left',
    next: 'chevron-right',
  };
  return (
    <button ref={buttonRef} className="group size-10 rounded-full bg-[white] p-2 hover:bg-bg-dark disabled:opacity-50 disabled:hover:bg-[white]">
      <Icons icon={typeToIcon[type]} className="group-hover:stroke-[white] group-disabled:group-hover:stroke-content-primary" />
    </button>
  );
};
